"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2771],{

/***/ 36060:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ Input; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var _Typography_index_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71323);
/* harmony import */ var _Shape_index_es_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(88123);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99902);
/* harmony import */ var _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(25989);
/* harmony import */ var _constants_index_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1902);
/* harmony import */ var _contexts_SizeContext_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34363);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21483);









var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Input = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)((_a, ref) => {
  var _b = _a, {
    title,
    value,
    defaultValue,
    autoFocus,
    type = "text",
    placeholder,
    caption,
    showCaptionIcon = true,
    error,
    disabled,
    readonly,
    prefix,
    suffix,
    maxLength = 255,
    className,
    onChange,
    onKeyDown,
    onFocus,
    onBlur,
    size: customizeSize,
    id
  } = _b, rest = __objRest(_b, [
    "title",
    "value",
    "defaultValue",
    "autoFocus",
    "type",
    "placeholder",
    "caption",
    "showCaptionIcon",
    "error",
    "disabled",
    "readonly",
    "prefix",
    "suffix",
    "maxLength",
    "className",
    "onChange",
    "onKeyDown",
    "onFocus",
    "onBlur",
    "size",
    "id"
  ]);
  var _a2, _b2;
  const size = react__WEBPACK_IMPORTED_MODULE_0__.useContext(_contexts_SizeContext_es_js__WEBPACK_IMPORTED_MODULE_2__/* .SizeContext */ .X);
  const mergeSize = customizeSize || size || "m";
  const handleFocus = (e) => {
    onFocus && onFocus(e);
  };
  const handleBlur = (e) => {
    onBlur && onBlur(e);
  };
  const colorState = disabled ? "disable" : error ? "error500" : void 0;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledInput, __spreadValues({
    className
  }, rest), title && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Typography_index_es_js__WEBPACK_IMPORTED_MODULE_3__/* .SubTitle */ .DK, {
    level: 4,
    color: "textPrimary",
    marginBottom: "s4"
  }, title), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(InputContainer, {
    className: "input-container",
    padding: ["s0", "s12"],
    borderWeight: "m",
    borderRadius: "s",
    borderStyle: "solid",
    height: _constants_index_es_js__WEBPACK_IMPORTED_MODULE_4__/* .MAPPING_SIZE */ .v[mergeSize],
    colorState: colorState || "primary500",
    readonly: !!readonly,
    disabled: !!disabled
  }, prefix && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledSpace, {
    height: _constants_index_es_js__WEBPACK_IMPORTED_MODULE_4__/* .MAPPING_SIZE */ .v[mergeSize],
    marginRight: "s4"
  }, typeof prefix === "string" ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Typography_index_es_js__WEBPACK_IMPORTED_MODULE_3__/* .Body */ .uT, {
    level: 2,
    color: disabled ? "border" : "textPrimary"
  }, prefix) : react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(prefix, {
    size: ((_a2 = prefix == null ? void 0 : prefix.props) == null ? void 0 : _a2.size) || 20
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledBaseInput, {
    ref,
    id,
    type,
    value,
    defaultValue,
    autoFocus,
    placeholder,
    onChange: (event) => onChange && onChange(event.target.value),
    onFocus: handleFocus,
    onBlur: handleBlur,
    maxLength,
    disabled,
    readOnly: readonly,
    backgroundColor: rest.backgroundColor || "",
    onKeyDown: (event) => {
      if (onKeyDown)
        onKeyDown(event);
    }
  }), suffix && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledSpace, {
    height: _constants_index_es_js__WEBPACK_IMPORTED_MODULE_4__/* .MAPPING_SIZE */ .v[mergeSize],
    marginLeft: "s4"
  }, typeof suffix === "string" ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Typography_index_es_js__WEBPACK_IMPORTED_MODULE_3__/* .Body */ .uT, {
    level: 2,
    color: disabled ? "border" : "textPrimary"
  }, suffix) : react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(suffix, {
    size: ((_b2 = suffix == null ? void 0 : suffix.props) == null ? void 0 : _b2.size) || 20
  }))), caption && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledSpace, {
    marginTop: "s8"
  }, showCaptionIcon && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_5__/* .CautionOutlined */ .s, {
    size: 16,
    color: colorState || "textSecondary"
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Typography_index_es_js__WEBPACK_IMPORTED_MODULE_3__/* .Caption */ .YS, {
    level: 1,
    color: colorState || "textSecondary",
    marginLeft: "s4"
  }, caption)));
});
Input.displayName = "Input";
const StyledInput = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div`
  ${_BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_6__/* .CommonStyles */ .F}
`;
const StyledBaseInput = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].input`
  background-color: ${(props) => props.backgroundColor ? props.backgroundColor + " !important" : "inherit"};
`;
const StyledSpace = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])(_Shape_index_es_js__WEBPACK_IMPORTED_MODULE_7__/* .Shape */ .b)`
  display: flex;
  align-items: center;
`;
const InputContainer = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])(_Shape_index_es_js__WEBPACK_IMPORTED_MODULE_7__/* .Shape */ .b)`
  display: flex;
  align-items: center;
  border-color: ${(p) => p.disabled ? p.theme.colors.background : p.theme.colors.inputBorder};

  :focus,
  :focus-within {
    border-color: ${(p) => p.theme.colors[p.colorState]};
  }

  ${(p) => p.disabled || p.readonly ? `background-color: ${p.theme.colors.background};` : p.theme.colors.white}
  overflow: hidden;
  input {
    flex: 1;
    width: 100%;
    border: none;
    font-size: 13px;
    color: ${(p) => p.disabled ? p.theme.colors.border : p.theme.colors.textPrimary};

    &::placeholder {
      color: ${(p) => p.disabled ? p.theme.colors.disable : p.theme.colors.placeholder};
    }
    &:focus {
      outline: none;
    }
    /* Chrome, Safari, Edge, Opera */
    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }
`;




/***/ }),

/***/ 89416:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ OrderShipments; }
/* harmony export */ });
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21483);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36344);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(48441);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(71323);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(58519);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(24122);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(13863);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(4680);
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(89104);
/* harmony import */ var i18next__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96556);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91987);
/* harmony import */ var _i18n_es_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(68481);
/* harmony import */ var _Shipment_Shipment_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96234);








var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const OrderShipments = (_a) => {
  var _b = _a, {
    shipments
  } = _b, rest = __objRest(_b, [
    "shipments"
  ]);
  var _a2, _b2, _c;
  const [shipmentVisible, setShipmentVisible] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)();
  const isShowTransportProviderInfo = !!(shipmentVisible == null ? void 0 : shipmentVisible.transportProviderName) || !!(shipmentVisible == null ? void 0 : shipmentVisible.transportTrackingId);
  const isShowStatusHistories = !!((_a2 = shipmentVisible == null ? void 0 : shipmentVisible.statusChangeHistories) == null ? void 0 : _a2.length);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Flex */ .k, __spreadProps(__spreadValues({}, rest), {
    direction: "column",
    gapY: "s16"
  }), shipments.map((shipment) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_Shipment_Shipment_es_js__WEBPACK_IMPORTED_MODULE_4__/* .Shipment */ .L, {
    shipment,
    key: shipment.shipmentId,
    onshowMore: () => {
      setShipmentVisible(shipment);
    }
  }))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* .Modal */ .u, {
    size: "l",
    visible: !!shipmentVisible,
    onClose: () => {
      setShipmentVisible(void 0);
    },
    cancelText: "",
    okText: (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_6__.t)("\u0110\xF3ng"),
    onOk: () => {
      setShipmentVisible(void 0);
    },
    title: /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__/* .Title */ .Dx, {
      weight: "medium"
    }, shipmentVisible == null ? void 0 : shipmentVisible.name, !!(shipmentVisible == null ? void 0 : shipmentVisible.shipmentId) && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, null, ":\xA0 ", "#", /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement("strong", null, shipmentVisible.shipmentId))),
    showCloseIcon: false
  }, (isShowTransportProviderInfo || isShowStatusHistories) && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Flex */ .k, null, isShowTransportProviderInfo && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__/* .Col */ .JX, {
    span: ((_b2 = shipmentVisible.statusChangeHistories) == null ? void 0 : _b2.length) ? 4.5 : 12,
    style: {
      paddingRight: "1rem"
    }
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Flex */ .k, {
    direction: "column",
    gapY: "s8"
  }, !!shipmentVisible.transportProviderName && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Flex */ .k, {
    color: "textSecondary",
    gap: "s4"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__/* .Body */ .uT, {
    weight: "regular"
  }, (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_6__.t)("Giao h\xE0ng b\u1EDFi"), ":"), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__/* .Body */ .uT, {
    weight: "bold"
  }, shipmentVisible.transportProviderName)), !!shipmentVisible.transportTrackingId && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Flex */ .k, {
    color: "textSecondary",
    gap: "s4"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__/* .Body */ .uT, {
    weight: "regular"
  }, (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_6__.t)("M\xE3 v\u1EADn \u0111\u01A1n"), ": \xA0"), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__/* .Button */ .z, __spreadValues({
    variant: "link",
    style: {
      textDecoration: "unset"
    }
  }, !!shipmentVisible.transportTrackingUrl ? { href: shipmentVisible.transportTrackingUrl } : {}), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__/* .Body */ .uT, null, shipmentVisible.transportTrackingId))))), isShowStatusHistories && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(ShipmentStatuses, {
    span: 7.5,
    style: {
      paddingLeft: "1rem"
    }
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(ShipmentStatusHistories, {
    histories: shipmentVisible.statusChangeHistories
  }))), !!((_c = shipmentVisible == null ? void 0 : shipmentVisible.invoiceItems) == null ? void 0 : _c.length) && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(ProductListWrapper, {
    direction: "column",
    gapY: "s16",
    marginTop: "s16"
  }, shipmentVisible.invoiceItems.map((item) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Flex */ .k, {
    key: item.sku,
    justify: "space-between",
    style: { width: "100%" },
    align: "start",
    gap: "s16"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Flex */ .k, {
    align: "start",
    gap: "s16"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(ProductImage, {
    src: item.imageUrl || "",
    width: 80,
    height: 80,
    aspectRatio: 1,
    contain: true,
    borderRadius: 4
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Flex */ .k, {
    direction: "column",
    gap: "s4"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__/* .Body */ .uT, {
    weight: "medium"
  }, item.name), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__/* .Caption */ .YS, {
    color: "textSecondary",
    weight: "medium"
  }, "SKU: ", item.sku), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Flex */ .k, {
    gap: "s4"
  }, !!item.sellerName && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__/* .Caption */ .YS, {
    color: "textSecondary",
    weight: "medium"
  }, (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_6__.t)("Cung c\u1EA5p b\u1EDFi"), " "), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__/* .Caption */ .YS, {
    color: "link"
  }, item.sellerName))))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Flex */ .k, {
    direction: "column",
    justify: "space-between",
    padding: ["s4", "s0"],
    gapY: "s16"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__/* .SubTitle */ .DK, {
    weight: "bold"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(StyledCurrency, {
    value: item.unitAfterTaxPrice || 0
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement("div", {
    style: {
      textAlign: "right",
      width: "100%",
      maxWidth: "100%"
    }
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__/* .Caption */ .YS, {
    color: "textSecondary"
  }, "x", item.quantity || 1))))))));
};
const ShipmentStatuses = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__/* .Col */ .JX)`
  border-left: 1px solid ${({ theme }) => theme.colors.divider};
`;
const DateTime = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__/* .Caption */ .YS)`
  line-height: 24px;
`;
const ShipmentStatusHistories = ({ histories }) => {
  const ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
  const [showMore, setShowMore] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)();
  const onShowMore = () => {
    if (!showMore) {
      if (ref.current) {
        ref.current.style.maxHeight = "999px";
      }
      setShowMore(true);
    } else {
      if (ref.current) {
        ref.current.style.maxHeight = "90px";
      }
      setShowMore(false);
    }
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(Wrapper, {
    ref
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(WrapperShipmentStatusHistories, {
    direction: "column",
    gapY: "s8"
  }, histories == null ? void 0 : histories.map((history, index) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(ShipmentStatusHistoryItem, {
    key: index,
    className: "history-item",
    align: "center",
    isActive: index === 0
  }, !!(history == null ? void 0 : history.changedAt) && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(DateTime, {
    color: "textSecondary",
    weight: "medium",
    marginLeft: "s8",
    style: { width: 150 }
  }, (0,_teko_utils__WEBPACK_IMPORTED_MODULE_10__/* .formatDate */ .p)(history.changedAt, i18next__WEBPACK_IMPORTED_MODULE_1__["default"].language || "vi")), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__/* .Body */ .uT, {
    marginBottom: "s4",
    color: "currentColor"
  }, history == null ? void 0 : history.status))))), ((histories == null ? void 0 : histories.length) || 0) > 3 && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__/* .Button */ .z, {
    variant: "link",
    paddingTop: "s16",
    onClick: onShowMore
  }, !showMore ? (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_6__.t)("Xem th\xEAm") : (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_6__.t)("Thu g\u1ECDn")));
};
const Wrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"].div`
  max-height: 90px;
  overflow: hidden;
  transition: max-height 0.3s ease-in-out;
  margin-bottom: 0.5rem;
`;
const WrapperShipmentStatusHistories = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Flex */ .k)`
  position: relative;

  overflow: hidden;
  ::before {
    content: '';
    position: absolute;
    top: 9px;
    left: 2px;
    width: 1px;
    height: calc(100% - 36px);
    border-left: 1px solid ${({ theme }) => theme.colors.divider};
    transform: translateX(50%);
  }
  > div:last-child {
    margin-bottom: 0.75rem;
  }
`;
const ShipmentStatusHistoryItem = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Flex */ .k)`
  position: relative;
  padding-left: 0.75rem;
  color: ${({ theme, isActive }) => isActive ? theme.colors.link : theme.colors.textSecondary};
  ::before {
    content: '';
    position: absolute;
    top: 9px;
    left: 0;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: ${({ theme, isActive }) => isActive ? theme.colors.link : theme.colors.divider};
  }
`;
const ProductListWrapper = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Flex */ .k)`
  border-top: 1px solid ${({ theme }) => theme.colors.divider};
  padding-top: 1rem;
  margin-top: 1rem;
  max-height: 340px;
  overflow-y: auto;

  ::-webkit-scrollbar {
    width: 0px;
  }
`;
const ProductImage = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_11__/* .LazyImage */ .w)`
  border: 1px solid ${({ theme }) => theme.colors.divider};
  min-width: 80px;
`;
const StyledCurrency = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_12__/* .Currency */ .F)`
  font-size: unset;
`;




/***/ }),

/***/ 96234:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ Shipment; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71323);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(24122);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(36344);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(21483);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(4680);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(31267);
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89104);
/* harmony import */ var i18next__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96556);
/* harmony import */ var _i18n_es_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(68481);







var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Shipment = (_a) => {
  var _b = _a, {
    shipment,
    onshowMore
  } = _b, rest = __objRest(_b, [
    "shipment",
    "onshowMore"
  ]);
  var _a2;
  const shipmentStatus = (_a2 = shipment.statusChangeHistories) == null ? void 0 : _a2[0];
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadProps(__spreadValues({}, rest), {
    align: "center",
    justify: "space-between"
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .SubTitle */ .DK, {
    weight: "bold",
    color: "textPrimary"
  }, shipment.name, !!shipment.shipmentId && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, ": \xA0", "#", shipment.shipmentId)), shipmentStatus && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ShipmentStatusWrapper, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .Body */ .uT, {
    color: "link",
    marginBottom: "s4"
  }, shipmentStatus == null ? void 0 : shipmentStatus.status), !!(shipmentStatus == null ? void 0 : shipmentStatus.changedAt) && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .Caption */ .YS, {
    color: "textSecondary",
    weight: "medium"
  }, (0,_teko_utils__WEBPACK_IMPORTED_MODULE_3__/* .formatDate */ .p)(shipmentStatus == null ? void 0 : shipmentStatus.changedAt, i18next__WEBPACK_IMPORTED_MODULE_1__["default"].language || "vi"))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .z, {
    variant: "link",
    suffix: /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_5__/* .ForwardOutlined */ .d, {
      size: 16
    }),
    onClick: onshowMore
  }, (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_6__.t)("Xem chi ti\u1EBFt"))), !!shipment.codAmount && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__/* .Flex */ .k, {
    gap: "s4"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .Body */ .uT, {
    color: "textSecondary"
  }, (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_6__.t)("C\u1EA7n thanh to\xE1n"), ":"), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .SubTitle */ .DK, {
    color: "primary600",
    weight: "bold"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledCurrency, {
    value: shipment.codAmount
  }))));
};
const Wrapper = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__/* .Flex */ .k)`
  border-radius: 8px;
  border: solid 1px ${({ theme }) => theme.colors.divider};
  padding: 0.75rem 1rem;
  width: 100%;
`;
const ShipmentStatusWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__["default"].div`
  position: relative;
  padding: 1px 1rem;
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;

  &::before {
    content: '';
    position: absolute;
    top: 6px;
    left: 4px;
    width: 1px;
    height: 80%;
    border-left: 1.5px solid ${({ theme }) => theme.colors.divider};
    transform: translateX(-50%);
  }
  &::after {
    top: 4px;
    content: '';
    position: absolute;
    left: 0;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: ${({ theme }) => theme.colors.link};
    border: 1px solid ${({ theme }) => theme.colors.divider};
  }
`;
const StyledCurrency = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__/* .Currency */ .F)`
  font-size: unset;
`;




/***/ })

}]);